import { EasyField } from '../baseClasses/easyField';
import { FieldOptions, SelectOption } from '../index';

export class EasyAutocompleteField extends EasyField {
  controlType = 'autocomplete';
  items: Array<string>;

  constructor(options: FieldOptions<any> = {}) {
    super(options);
    options.controlType = this.controlType;
  }

  setItems(items: Array<string>) {
    this.items = items;
  }
}


